import { createFileRoute } from "@tanstack/react-router";
import { optionalStringParam, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

const searchSchema = parseableSearchSchema(
  Schema.Struct({
    date: optionalStringParam(),
    coachId: optionalStringParam(),
  }),
);

export const Route = createFileRoute("/_protected/dashboard/coach-daily-analysis/")({
  head: () => ({
    meta: [{ title: "教练日报分析 · imiker CRM" }],
  }),
  validateSearch: searchSchema
});
